<div style="text-align: center">
    <img src="/assets/logo-small.png"
         alt="adapt Logo"
         class="adapt-logo" />

    <h1>Lumia Meeting</h1>

    <p>Add your meetings to Lumia</p>

    <button (click)="openLogInDialog()"
            data-test="start-button">Get Started</button>
</div>
